import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Menu, Dropdown, Icon, Label } from 'semantic-ui-react';
import { useStore } from '../stores/store';
import '../common/MediaQuery/responsive-navbar.css';
import { useEffect, useState } from 'react';
import { userLanguage } from '../common/userLanguageSchema/userLanguage';
// import GitInfo from 'react-git-info/macro';
import ImageTag from '../../features/Profile/RenderImage';
import RenderImage from '../../features/Profile/RenderImage';

const languageOptions = [
  { key: 'En', text: 'English', flag: 'us', value: 'English' },
  { key: 'Hi', text: 'Hindi', flag: 'in', value: 'Hindi' },
  { key: 'Ta', text: 'Tamil', flag: 'in', value: 'Tamil' },
  { key: 'Ar', text: 'Arabic', flag: 'ae', value: 'Arabic' },
  { key: 'Et', text: 'Estonian', flag: 'ee', value: 'Estonian' },
  { key: 'Fr', text: 'French', flag: 'fr', value: 'French' },
  { key: 'Ge', text: 'German', flag: 'de', value: 'German' },
  { key: 'Ja', text: 'Japanese', flag: 'jp', value: 'Japanese' },
  { key: 'Ma', text: 'Marathi', flag: 'in', value: 'Marathi' },
  { key: 'Ml', text: 'Malayalam', flag: 'in', value: 'Malayalam' },
];

export default observer(function NavBar() {
  const {
    userStore: {
      user,
      logout,
      isInstantPageLogin,
      instantpageUsernameAndEmailValidate,
      appLogo,
      getLogo,
    },
    sidebarStore,
    dashboardStore,
    commonStore,
    userStore,
  } = useStore();
  const history = useNavigate();
  const [emailCount, setEmailCount] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);

  // const logout = () => {
  //   localStorage.removeItem('token-info');
  //   //setIsLoggedin(false);
  // };

  useEffect(() => {
    getLogo();
    // eslint-disable-next-line
  }, []);

  const routeChange = (path: string) => {
    history(path);
  };

  useEffect(() => {
    const resizeHandler = () => {
      if (window.innerWidth > 767) {
        setIsMobileView(false);
      } else {
        setIsMobileView(true);
      }
    };
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => window.removeEventListener('resize', resizeHandler);
  }, []);

  useEffect(() => {
    setEmailCount(dashboardStore.dashboard.messageCount);
  }, [dashboardStore.dashboard.messageCount]);

  const onChangeHandler = (_e: any, data: any) => {
    let index = languageOptions.findIndex((d) => d.value === data.value);
    commonStore.language = languageOptions[index];
    localStorage.setItem(
      'customerLanguageSelection',
      JSON.stringify(languageOptions[index]),
    );
  };

  useEffect(() => {
    let customerName = user?.customerName || '';
    //localStorage.getItem("customerLanguagedefault",commonStore.language.key)
    let language: any = JSON.parse(
      localStorage.getItem('customerLanguageSelection') || '{}',
    );
    commonStore.language = language;

    if (language?.key) return;
    switch (customerName) {
      case 'VMS HCM EFX':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        //localStorage.setItem("customerLanguageSelection",commonStore.language.key)
        break;
      case 'PC Technology':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'NFAI':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'NFAI Pune':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Prasad Hyderabad':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Prasad Multiplex':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Prasad IT':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Kalaignar TV':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'IITM':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'DFT':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'DFT Demo':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'LVPCMS':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Ratus':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Demo':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Trial':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'touchstone':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'Prasad Film labs':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      case 'TestCustomerss':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      // case "Prasad Film labs":
      // commonStore.language = { key: "Fr", text: "French", flag: "fr",value: "French" };
      // break;
      case 'Prasad Studio':
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
        break;
      default:
        commonStore.language = {
          key: 'En',
          text: 'English',
          flag: 'us',
          value: 'English',
        };
    }
    // eslint-disable-next-line
  }, []);

  //
  // if (commonStore.token) {
  //   userStore.getUser().finally(() => commonStore.setAppLoaded());
  // } else {
  //   commonStore.setAppLoaded();
  // }
  // //
  // if((localStorage.getItem('En') === commonStore.language.key || localStorage.getItem('userLanguage') === null) || localStorage.getItem('userLanguage') === "") {
  //   //localStorage.setItem(commonStore.language.key === commonStore.language.key)
  //   //('userLanguage', value={commonStore.language.text}, "value=userLanguage.languageOptions.Key")
  // }

  // const gitInfo = GitInfo();
  return (
    <Menu
      inverted
      fixed="top"
      size="large"
      className={
        userStore.user?.customerName === 'Isha Foundation'
          ? 'navbarIshaStyle'
          : 'navbarStyle'
      }
      // className="nav-style"
    >
      <Menu.Item header position="left">
        {commonStore.filterModeTwo?.includes(
          '302bbc41-d079-4199-9cc0-2f1806b442f7',
        ) ? (
          <></>
        ) : (
          <>
            {(user?.customerName !== 'NFAI' ||
              window.innerWidth > 1025 ||
              window.innerWidth < 1020) && (
              <Icon
                name="content"
                circular
                // style={{alignItems: "center"}}
                //if {...user?.customerName === 'LVPCMS'  && !isMobileView &&
                //defaultValue={commonStore.language.text}
                //defaultValue={commonStore.language.key.indexOf(userLanguage)}
                // }
                // {user?.email === 'demo.prasadcorp@gmail.com'  && !isMobileView &&
                onClick={() =>
                  sidebarStore.sidebar.open
                    ? sidebarStore.closeSidebar()
                    : sidebarStore.openSidebar()
                }
                disabled={commonStore.filterModeZero?.includes(
                  '302bbc41-d079-4199-9cc0-2f1806b442f7',
                )}
              />
            )}
          </>
        )}

        {user?.customerName === 'Area 51' ? (
          <img
            src={'/assets/area51.png'}
            alt="logo"
            style={{ marginLeft: '10px', width: '90px' }}
          />
        ) : user?.customerName === 'Paramount Global' ? (
          <img
            src={'/assets/paramount.png'}
            alt="logo"
            style={{ marginLeft: '10px', width: '150px' }}
          />
        ) : [
            'HFC Media Services',
            'Redbud',
            'Magnolia Pictures',
            'Dogwood',
            'Buckeye',
            'TC Fox Disney',
            'Walt Disney',
            'Paramount Inventory',
            'North Block Inc.',
            'Netflix Inventory',
          ].includes(user?.customerName as string) ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1683893697/sfjftefmtkiye8bdk4vm.png'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '8em' }}
          />
        ) : user?.customerName === 'Museum' ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1688531557/qsokjnxgue1cssxkd5rj.png'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '8em' }}
          />
        ) : user?.customerName === 'SRM' ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1692246541/eu9hedlovh6cfiyr2iij.webp'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '8em' }}
          />
        ) : user?.customerName === 'RAI' ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1693809496/gzo2fq3j9vuq11mxjaji.png'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '8em' }}
          />
        ) : user?.customerName === 'Prasad Corp' ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1693809649/bxanoc6e2v9nc3jrvecq.png'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '8em' }}
          />
        ) : user?.customerName === 'Isha Foundation' ? (
          <img
            src={
              'https://res.cloudinary.com/drvaemi9t/image/upload/v1696578097/mo60difwe3wyls7hsbo8.svg'
            }
            alt="logo"
            style={{ marginLeft: '10px', width: '56px', height: '56px' }}
          />
        ) : (
          <RenderImage
            imageUrl={appLogo.logoUrl}
            defaultUrl={'/assets/logo.png'}
            style={{ marginLeft: '10px', width: '8em', maxHeight: '4em' }}
          />
        )}
      </Menu.Item>
      <Menu.Item className="navbarOptions" position="right">
        <>
          {user?.customerName === 'Paramount Global'
            ? null
            : !isMobileView && (
                <div className={'languageDropdown'}>
                  <Dropdown
                    placeholder="Select Language"
                    fluid
                    fluent="true"
                    search
                    selection
                    value={commonStore.language.text}
                    options={languageOptions}
                    onChange={onChangeHandler}
                  />
                </div>
              )}
        </>

        {!isMobileView && (
          <Menu.Item
            disabled={
              dashboardStore.dashboard.selectedUserRoleId.includes('DB02')
                ? false
                : true
            }
            onClick={() => routeChange('/')}
            size="mini"
            style={{ marginTop: '-2px' }}
          >
            <Icon name="home" />
          </Menu.Item>
        )}
        {commonStore.filterModeTwo?.includes('DB03') ? (
          <></>
        ) : (
          <Menu.Item
            disabled={commonStore.filterModeZero?.includes('DB03')}
            onClick={() => routeChange('/message')}
            size="mini"
            style={{ padding: '0px 0px 0px 0px', margin: '0 auto' }}
          >
            <Icon
              name="mail"
              disabled={commonStore.filterModeZero?.includes('DB03')}
            />
            {commonStore.filterModeOne?.includes('DB03') && (
              <Label color="teal" floating>
                {emailCount}
              </Label>
            )}
          </Menu.Item>
        )}
        <ImageTag
          avatar={true}
          imageUrl={user?.image}
          defaultUrl="/assets/user.png"
          spaced="right"
        />
        <Dropdown
          className="userNameNavbar"
          pointing="top right"
          text={user?.displayName}
        >
          <Dropdown.Menu>
            {commonStore.filterModeTwo?.includes('UDDB1') ? (
              <></>
            ) : (
              <Dropdown.Item
                text={
                  (userLanguage[0].User.UDDB1 as any)?.[
                    `${commonStore.language.key}`
                  ]
                } //"My Profile"
                icon="user"
                onClick={() => routeChange(`/profile/${user?.username}`)}
                disabled={commonStore.filterModeZero?.includes('UDDB1')}
              />
            )}

            {/* <Dropdown.Item
              text={
                (userLanguage[0].User.UDDB1 as any)?.[
                  `${commonStore.language.key}`
                ]
              } //"My Profile"
              icon="user"
              onClick={() => routeChange(`/profile/${user?.username}`)}
            /> */}
            <Dropdown.Item
              onClick={() => {
                if (instantpageUsernameAndEmailValidate === '') {
                  history('/');
                } else if (!isInstantPageLogin) {
                  history('/InstantPage');
                }
                logout();
              }}
              //localStorage.clear();
              text={
                (userLanguage[0].User.UDDB2 as any)?.[
                  `${commonStore.language.key}`
                ]
              } //"Logout"
              icon="power"
            />
            <Dropdown.Item text={new Date().toLocaleDateString()} />
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Item>
    </Menu>
  );
});
